import { routes } from '../config/api_routes'

export const IncentiveService = {
    storeExtraIncentives: (formData) => {    
        return window.axios.post(routes.storeExtraIncentivesApi,formData)
    }, 

	removeAllIncentives: (formData) => {
		return window.axios.post(routes.removeAllExtraIncentivesApi,formData)
	},
	
	fetchIncentives: (formData) => {
		return window.axios.post(routes.fetchIncentivesApi,formData)
	},

	removeIncentive: (formData) => {
		return window.axios.post(routes.removeIncentiveApi,formData)
	},
}